import { CalendarTaskSync } from '@griply/types';
import React, { useMemo } from 'react';
import { Heart, IconFormIcons } from 'shared/assets/icons';
import { TaskCardContextMenu } from 'shared/components/connected/task-card-context-menu';
import { Icon } from 'shared/components/ui/icon';
import { useContextMenuState } from 'shared/hooks/use-context-menu-state';
import { ID } from 'shared/types/id';
import { LifeArea } from 'shared/types/life-area';
import { Task } from 'shared/types/task';
import { TaskActionLifeArea } from 'shared/types/task-action';

import * as Styled from './event.style';
import { EventCard } from './event-card';
import { TaskEventSyncBadge } from './task-event-sync-badge';

export type LifeAreaEventProps = {
  task: Task;
  lifeAreas: LifeArea[];
  onClick?: (id: ID) => void;
  numberOfLines: number;
  timeText?: string;
  completed?: boolean;
  onInteractionComplete?: () => void;
  calendarSync?: CalendarTaskSync;
};

export const TaskLifeAreaEvent: React.FC<LifeAreaEventProps> = ({
  task,
  lifeAreas,
  onClick,
  numberOfLines,
  timeText,
  completed,
  onInteractionComplete,
  calendarSync,
}) => {
  const {
    open: openMenu,
    close: closeMenu,
    position: menuPosition,
  } = useContextMenuState();
  const _onClick = () => onClick?.(task.id);

  const lifeArea = useMemo(
    () =>
      lifeAreas.find(
        ({ id }) => id === (task.action as TaskActionLifeArea)?.meta?.id,
      ),
    [lifeAreas, task.action],
  );

  if (!lifeArea) {
    return null;
  }

  return (
    <>
      <EventCard
        title={lifeArea.name}
        color={lifeArea.color ?? undefined}
        timeText={timeText}
        completed={completed}
        numberOfLines={numberOfLines}
        onClick={_onClick}
        onContextMenu={openMenu}
        trailing={
          <TaskEventSyncBadge
            task={task}
            calendarSync={calendarSync}
            color={lifeArea.color ?? undefined}
          />
        }
        leading={
          <Styled.LeadingSlot
            $color={lifeArea.color ?? undefined}
            $completed={completed}
          >
            <Icon icon={IconFormIcons[lifeArea.iconName] ?? Heart} />
          </Styled.LeadingSlot>
        }
      />

      {!!menuPosition && (
        <TaskCardContextMenu
          task={task}
          onClose={closeMenu}
          location={menuPosition}
          onAction={onInteractionComplete}
          showCalendarSync
        />
      )}
    </>
  );
};
